export default __webpack_public_path__ + "static/aburt-15b82fec8590af7c2ee000f42e18ca93.png";